import React from 'react';
import PropTypes from 'prop-types';
import { chartTheme } from './chartTheme';
import { defaultValueFormatter, defaultDateTooltipFormatter } from './formatters';

export function YChartTooltip({
  active,
  payload,
  label,
  labelFormatter = defaultDateTooltipFormatter,
  valueFormatter = defaultValueFormatter
}) {
  if (!active || !payload || payload.length === 0) return null;
  const displayLabel = labelFormatter ? labelFormatter(label) : label;

  return (
    <div
      className="y-chart-tooltip"
      style={{
        background: chartTheme.tooltipBackground,
        border: chartTheme.tooltipBorder,
        boxShadow: chartTheme.tooltipShadow,
        borderRadius: chartTheme.tooltipRadius,
        color: chartTheme.tooltipText
      }}
    >
      {displayLabel && <div className="y-chart-tooltip__label">{displayLabel}</div>}
      <ul className="y-chart-tooltip__list">
        {payload.map((entry) => {
          if (entry == null) return null;
          const stroke = entry.color || entry.stroke || entry.fill || chartTheme.accent;
          const name = entry.name || entry.dataKey;
          return (
            <li key={`${entry.dataKey}-${name}`} className="y-chart-tooltip__item">
              <span
                className="y-chart-tooltip__dot"
                aria-hidden="true"
                style={{ backgroundColor: stroke }}
              />
              <div className="y-chart-tooltip__content">
                <span className="y-chart-tooltip__series">{name}</span>
                <span className="y-chart-tooltip__value">
                  {valueFormatter(entry.value, name, entry)}
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

YChartTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelFormatter: PropTypes.func,
  valueFormatter: PropTypes.func
};

export default YChartTooltip;

